"use client";

import Icon from "@/components/Icon";

type RoadmapEmptyStateProps = {
	message?: string;
};

export function RoadmapEmptyState({
	message = "No roadmap items",
}: RoadmapEmptyStateProps) {
	return (
		<div className="flex h-full w-full flex-col items-center justify-center rounded-lg border border-dashed px-8 py-40 text-center">
			<Icon name="Search" className="mb-4 h-12 w-12 text-muted-foreground" />
			<h3 className="font-semibold text-lg">{message}</h3>
			<p className="text-muted-foreground text-sm">
				Try adjusting your search or filters to find what you're looking for.
			</p>
		</div>
	);
}
